import api from '../utils/api';
export const getConversationList = async (page = 1, limit = 10) => {
  try {
    const res = await api.get('/v1/user/chat-server/conversations', {
      params: { page, limit },
      headers: {
        'Content-Type': 'application/json',
        Scope: 'multi-me',
      },
    });

    return res.data; // axios tự parse JSON
  } catch (error) {
    console.error(
      'Failed to fetch getConversationList:',
      error?.data || error.message
    );
    throw new Error('Unable to fetch getConversationList');
  }
};

export const createChannel = async ({ userId }) => {
  try {
    const res = await api.post(
      '/v1/user/chat-server/create',
      { user_id: Number(userId) },
      {
        headers: {
          'Content-Type': 'application/json',
          Scope: 'multi-me',
        },
      }
    );

    return res.data; // Axios tự parse JSON
  } catch (error) {
    console.error('Failed to create channel:', error?.data || error.message);
    throw new Error('Unable to create channel');
  }
};

/**
 * Xin token mới cho một kênh đã có. Token chat-server sống ~24h, hết hạn thì
 * WebSocket bị đóng với mã 4401 và SDK không tự kết nối lại.
 */
export const refreshChannelToken = async ({ channelId }) => {
  try {
    const res = await api.post(
      '/v1/user/chat-server/refresh-token',
      { channel_id: channelId },
      {
        headers: {
          'Content-Type': 'application/json',
          Scope: 'multi-me',
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Failed to refresh channel token:', error?.data || error.message);
    throw new Error('Unable to refresh channel token');
  }
};

export async function getAdminToken(userId) {
  const url = `/v1/user/conversation/personal-update-token?userId=${encodeURIComponent(
    userId
  )}`;

  try {
    const res = await api.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Scope: 'multi-me',
      },
    });

    return res?.data?.data;
  } catch (error) {
    console.error('Failed to fetch admin token:', error.message);
    throw new Error('Unable to fetch admin token');
  }
}

export async function getPresenceToken(userId) {
  const url = `/v1/user/conversation/presence-token?userId=${encodeURIComponent(
    userId
  )}`;

  try {
    const res = await api.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Scope: 'multi-me',
      },
    });

    return res?.data?.data; // hoặc res?.data?.count tuỳ API trả về
  } catch (error) {
    console.error('Failed to fetch presence token:', error.message);
    throw new Error('Unable to fetch presence token');
  }
}
export async function markMessageReadAndStatus(payload) {
  const url = `/v1/user/mark-read-and-status`;

  try {
    const res = await api.post(url, payload, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Scope: 'strongbody-ai',
      },
    });

    return res?.data; // hoặc res?.data?.data nếu API trả về dạng { data: ... }
  } catch (error) {
    console.error('Failed to mark message as read:', error.message);
    throw new Error('Unable to mark message as read');
  }
}
export async function getUnreadMessageCount() {
  const url = `/v1/user/unread-counts`;

  try {
    const res = await api.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Scope: 'strongbody-ai',
      },
    });

    return res?.data?.data; // hoặc res?.data?.count tuỳ API trả về
  } catch (error) {
    console.error('Failed to fetch unread messages:', error.message);
    throw new Error('Unable to fetch unread messages');
  }
}
